// appsignal.js
import Appsignal from "@appsignal/javascript";
import lastCommitHash from '../lastCommitHash.js'

export const appsignal = new Appsignal({
  key: "d0b48cc6-d34c-43ea-86bf-569e01c94128", // Replace with your actual Frontend API key
  namespace: "frontend", // Optional: Group front-end errors under a specific namespace
  revision: lastCommitHash.hash,
});